module.exports = __webpack_public_path__ + "static/GoogleCloud-91ea79a6b1edadd1faa71e1374d0cb55.png";